import { render, staticRenderFns } from "./SavedSearchModal.vue?vue&type=template&id=1373622a&"
import script from "./SavedSearchModal.vue?vue&type=script&lang=js&"
export * from "./SavedSearchModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports